// Copyright (c) 2020 WiseTime. All rights reserved.

import { createAction } from "@reduxjs/toolkit"
import { CreateUserCueRequest } from "../../generated/wisetime/user/cues/v4/user_cues_pb"

export const createUserCue = createAction<CreateUserCueRequest>("user-cues/create-user-cue")
export const createUserCueFailed = createAction("user-cues/create-user-cue-failed")
